import { useState } from "react";
import { galleryTabs } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

export default function Gallery() {
  const [active, setActive] = useState(0);
  const tab = galleryTabs[active];

  return (
    <section id="gallery" className="scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="截图全景对比"
            title="不同平台的图，放一起才看得清"
            desc="同一事件在聊天记录、朋友圈与评论区往往说法不同。切换页签并排对照，快速看出前后矛盾在哪。"
          />
          <div
            className="mb-8 flex items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1 md:mb-10"
            role="tablist"
            aria-label="截图来源切换"
          >
            {galleryTabs.map((t, i) => (
              <button
                key={t.label}
                role="tab"
                aria-selected={active === i}
                onClick={() => setActive(i)}
                className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition ${
                  active === i
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                <i className={`${t.icon} ${active === i ? "" : "text-primary-400"}`} />
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-100/60">
          <div className="grid lg:grid-cols-[1fr_0.9fr]">
            <div className="grid grid-cols-2 gap-3 p-4 md:p-6">
              {tab.imgs.map((src, i) => (
                <figure key={i} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                  <img
                    src={src}
                    alt={`${tab.label}对照图 ${i + 1}`}
                    className="aspect-[9/10] w-full object-cover"
                  />
                </figure>
              ))}
            </div>
            <div className="flex flex-col justify-center border-t border-background-200 p-6 md:p-10 lg:border-l lg:border-t-0">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-100 text-accent-700">
                <i className={`${tab.icon} text-2xl`} />
              </div>
              <h3 className="mt-5 font-heading text-2xl font-bold text-foreground-950">{tab.label}整理</h3>
              <p className="mt-3 leading-relaxed text-foreground-600">{tab.note}</p>
              <ul className="mt-6 flex flex-col gap-2.5 text-sm text-foreground-600">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500" />
                  仅收录公开可检索或已授权打码的内容
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500" />
                  标注来源类型，多方说法并列呈现
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500" />
                  关键差异点用高亮标注，便于对比
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}